module.exports = __webpack_public_path__ + "img/blue-bckarrow.1911c79d.svg";